module.exports = __webpack_public_path__ + "img/btn_VM_gameData.7780bfac.svg";